module.exports = __webpack_public_path__ + "static/media/Maintenance_banner.97f92997.png";